import InputForm from "./InputForm";
import { formatRut } from "../../validations/format"

// Formatea el RUT en forma x.xxx.xxx-x mientras se escribe
const styles = {
  toggleText: { marginTop: "1rem" },
  link: {
    cursor: "pointer",
  },
};

function InputIdentificacion({
  identificacion,
  setIdentificacion,
  modo,
  setModo,
  error,
  setError,
}) {

  return (
    <div>
      {modo === "rut" ? (
        <>
          <InputForm
            id="rut"
            label="RUT Estudiante"
            placeholder="12.345.678-9"
            value={identificacion}
            onChange={(e) => setIdentificacion(formatRut(e.target.value))}
            error={modo === "rut" ? error : ""} // solo muestra error si estamos en RUT
          />
          <p className="mt-1">
            <span
            className="text-muted fs-6"
              onClick={() => {
                setIdentificacion("");
                setModo("pasaporte");
                setError("");
              }}
              style={styles.link}
            >
              ¿No tienes RUT? Ingresa con tu pasaporte
            </span>
          </p>
        </>
      ) : (
        <>
          <InputForm
            id="pasaporte"
            label="Pasaporte Estudiante"
            placeholder="AB1234567"
            value={identificacion}
            onChange={(e) => setIdentificacion(e.target.value.toUpperCase())}
            error={modo === "pasaporte" ? error : ""} // solo muestra error si estamos en Pasaporte
          />
          <p className="mt-1">
            <span
              onClick={() => {
                setIdentificacion("");
                setModo("rut");
                setError("");
              }}
              style={styles.link}
            >
              ¿Tienes RUT? Ingresa con tu RUT
            </span>
          </p>
        </>
      )}
    </div>
  );
}

export default InputIdentificacion;